// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* About Page Festival Accordion Component - Completely Isolated */
.about-festival-accordion-container {
  max-width: 1500px;
  margin: 0 auto;
  padding: 2rem;
}

.about-festival-accordion-item {
  background-color: var(--color-white);
  margin-bottom: 20px;
  border-radius: 0;
  overflow: hidden;
}

.about-festival-accordion-header {
  background-color: var(--color-white);
  color: var(--color-black);
  padding: 1.5rem 2rem;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background-color 0.3s ease;
  border-bottom: 1px solid #e0e0e0;
}

.about-festival-accordion-header:hover {
  background-color: #f5f5f5;
}

.about-festival-accordion-header h3 {
  margin: 0;
  font-size: 4rem;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--color-black);
  font-family: var(--font-family-scrolling);
}

.about-accordion-icon {
  font-size: 2rem;
  font-weight: 300;
  color: var(--color-primary);
  transition: transform 0.3s ease;
}

.about-accordion-icon.open {
  transform: rotate(180deg);
}

.about-festival-accordion-content {
  background-color: var(--color-white);
  animation: aboutSlideDown 0.3s ease;
}

@keyframes aboutSlideDown {
  from {
    max-height: 0;
    opacity: 0;
  }
  to {
    max-height: 800px;
    opacity: 1;
  }
}

.about-festival-content-inner {
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.about-festival-description {
  color: var(--color-black);
}

.about-festival-description p {
  font-size: 1rem;
  line-height: 1.6;
  margin: 0;
  color: var(--color-black);
}

.about-festival-banner {
  margin: 0 -2rem;
}

.about-festival-banner img {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
}

.about-festival-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: var(--color-text-secondary);
}

.about-festival-website-link {
  color: var(--color-text-secondary);
  text-decoration: none;
  font-weight: 600;
  font-size: 1rem;
}

.about-festival-website-link:hover {
  text-decoration: underline;
}

.about-festival-social-links {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.about-social-link {
  color: var(--color-text-secondary);
  font-size: 1.2rem;
  text-decoration: none;
  transition: transform 0.3s ease;
}

.about-social-link:hover {
  transform: scale(1.2);
}

/* Responsive Design */
@media (max-width: 768px) {
  .about-festival-accordion-container {
    padding: 1rem;
  }

  .about-festival-accordion-header {
    padding: 1rem 1.5rem;
  }

  .about-festival-accordion-header h3 {
    font-size: 2.5rem;
  }

  .about-festival-content-inner {
    padding: 1.5rem;
    gap: 1.5rem;
  }

  .about-festival-banner {
    margin: 0 -1.5rem;
  }

  .about-festival-footer {
    flex-direction: column;
    gap: 1rem;
    align-items: flex-start;
  }

  .about-festival-social-links {
    align-self: flex-end;
  }
}

@media (max-width: 615px) {
  .about-festival-accordion-header h3 {
    font-size: 1.6rem;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/FestivalAccordion/FestivalAccordion.css"],"names":[],"mappings":"AAAA,kEAAkE;AAClE;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,oBAAoB;EACpB,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE;IACE,aAAa;IACb,UAAU;EACZ;EACA;IACE,iBAAiB;IACjB,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* About Page Festival Accordion Component - Completely Isolated */\n.about-festival-accordion-container {\n  max-width: 1500px;\n  margin: 0 auto;\n  padding: 2rem;\n}\n\n.about-festival-accordion-item {\n  background-color: var(--color-white);\n  margin-bottom: 20px;\n  border-radius: 0;\n  overflow: hidden;\n}\n\n.about-festival-accordion-header {\n  background-color: var(--color-white);\n  color: var(--color-black);\n  padding: 1.5rem 2rem;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  transition: background-color 0.3s ease;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.about-festival-accordion-header:hover {\n  background-color: #f5f5f5;\n}\n\n.about-festival-accordion-header h3 {\n  margin: 0;\n  font-size: 4rem;\n  font-weight: 400;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: var(--color-black);\n  font-family: var(--font-family-scrolling);\n}\n\n.about-accordion-icon {\n  font-size: 2rem;\n  font-weight: 300;\n  color: var(--color-primary);\n  transition: transform 0.3s ease;\n}\n\n.about-accordion-icon.open {\n  transform: rotate(180deg);\n}\n\n.about-festival-accordion-content {\n  background-color: var(--color-white);\n  animation: aboutSlideDown 0.3s ease;\n}\n\n@keyframes aboutSlideDown {\n  from {\n    max-height: 0;\n    opacity: 0;\n  }\n  to {\n    max-height: 800px;\n    opacity: 1;\n  }\n}\n\n.about-festival-content-inner {\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.about-festival-description {\n  color: var(--color-black);\n}\n\n.about-festival-description p {\n  font-size: 1rem;\n  line-height: 1.6;\n  margin: 0;\n  color: var(--color-black);\n}\n\n.about-festival-banner {\n  margin: 0 -2rem;\n}\n\n.about-festival-banner img {\n  width: 100%;\n  height: auto;\n  display: block;\n  object-fit: cover;\n}\n\n.about-festival-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  color: var(--color-text-secondary);\n}\n\n.about-festival-website-link {\n  color: var(--color-text-secondary);\n  text-decoration: none;\n  font-weight: 600;\n  font-size: 1rem;\n}\n\n.about-festival-website-link:hover {\n  text-decoration: underline;\n}\n\n.about-festival-social-links {\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n}\n\n.about-social-link {\n  color: var(--color-text-secondary);\n  font-size: 1.2rem;\n  text-decoration: none;\n  transition: transform 0.3s ease;\n}\n\n.about-social-link:hover {\n  transform: scale(1.2);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .about-festival-accordion-container {\n    padding: 1rem;\n  }\n\n  .about-festival-accordion-header {\n    padding: 1rem 1.5rem;\n  }\n\n  .about-festival-accordion-header h3 {\n    font-size: 2.5rem;\n  }\n\n  .about-festival-content-inner {\n    padding: 1.5rem;\n    gap: 1.5rem;\n  }\n\n  .about-festival-banner {\n    margin: 0 -1.5rem;\n  }\n\n  .about-festival-footer {\n    flex-direction: column;\n    gap: 1rem;\n    align-items: flex-start;\n  }\n\n  .about-festival-social-links {\n    align-self: flex-end;\n  }\n}\n\n@media (max-width: 615px) {\n  .about-festival-accordion-header h3 {\n    font-size: 1.6rem;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
